import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { getStreamId } from './helpers';
import { getCommentableTypeForDeviationType } from '../DeviationPage/redux/helpers';
import { createCallbackActionCreator } from '../Stream/helpers';
export var initializeThread = createAction("".concat(actionTypePrefix, "/INITIALIZE"), function (_a) {
    var thread = _a.thread, maxDepth = _a.maxDepth, itemsPerFetch = _a.itemsPerFetch;
    return ({
        thread: thread,
        maxDepth: maxDepth,
        itemsPerFetch: itemsPerFetch,
    });
});
export var initializeThreadFromPapi = function (_a) {
    var hasMore = _a.hasMore, hasLess = _a.hasLess, thread = _a.thread, total = _a.total, canPostComment = _a.canPostComment, commentableItemid = _a.commentableItemid, commentableTypeid = _a.commentableTypeid, cursor = _a.cursor, prevCursor = _a.prevCursor;
    return initializeThread({
        thread: {
            commentableItemId: commentableItemid,
            commentableTypeId: commentableTypeid,
            hasMore: hasMore,
            hasLess: hasLess,
            items: thread,
            total: total,
            canPostComment: canPostComment,
            cursor: cursor || undefined,
            prevCursor: prevCursor || undefined,
        },
    });
};
export var initializeEmptyThread = function (commentableItemId, commentableTypeId) {
    return initializeThread({
        thread: {
            commentableItemId: commentableItemId,
            commentableTypeId: commentableTypeId,
            hasMore: false,
            hasLess: false,
            items: [],
            total: 0,
            canPostComment: false,
        },
    });
};
export var streamIdChanged = createAction("".concat(actionTypePrefix, "/STREAM_ID_CHANGED"), function (config) { return config; });
export var changeOrder = createAction("".concat(actionTypePrefix, "/CHANGE_ORDER"), function (streamId, order) {
    return { order: order, streamId: streamId };
});
export var threadUpdated = createAction("".concat(actionTypePrefix, "/THREAD_UPDATED"), function (streamId, result) {
    return { streamId: streamId, result: result };
});
export var deviationThreadUpdated = function (deviation, result) {
    return threadUpdated(getStreamId(getCommentableTypeForDeviationType(deviation.typeId), deviation.deviationId), result);
};
export var fetchNextInThread = createCallbackActionCreator("".concat(actionTypePrefix, "/THREAD_FETCH_NEXT"));
export var fetchPreviousInThread = createCallbackActionCreator("".concat(actionTypePrefix, "/THREAD_FETCH_PREV"));
//# sourceMappingURL=actionCreators.js.map